import React, { useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import IconPotongGambar from '../assets/icon/icon_potong_gambar.png';

const ImageEditor = ({ src, onCrop, onClose }) => {
  const cropperRef = useRef(null);

  const handleCrop = () => {
    const cropper = cropperRef.current.cropper;
    onCrop(cropper.getCroppedCanvas().toDataURL());
  };

  return (
    <div className="flex flex-col items-center">
      {src ? (
        <div className="">
          <Cropper
            src={src}
            className="w-full h-full md:h-[480px] md:w-[720px]"
            //style={{ height: 480, width: 720 }}
            initialAspectRatio={1}
            guides={false}
            ref={cropperRef}
          />
        </div>
      ) : (
        <p>Unggah atau ambil foto terlebih dahulu</p>
      )}
      <button onClick={handleCrop} className="w-[150px] text-white mt-4">
        <img src={IconPotongGambar} alt="" className="w-full object-contain" />
      </button>
      <button
        onClick={onClose}
        className="bg-red-500 text-white px-4 py-2 rounded mt-2">
        Batal
      </button>
    </div>
  );
};

export default ImageEditor;
